import React, { useEffect, useRef, useState } from "react";
import "./BybAnalysis.css";
// import Analysis from "../../assets/images/analysis.jpeg";
// import position from "../../assets/images/position.svg";
// import strength from "../../assets/images/strength.svg";
// import unique from "../../assets/images/unique.svg";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import marketingPractice from "../../assets/images/marketing-practice.svg";


function ExpertsInsight() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);


  const textRef = useRef(null);
    // Intersection Observer for fade-in text
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsVisible(entry.isIntersecting); // Set visibility based on intersection
        },
        {
          threshold: 0.5, // Trigger when 50% of the element is visible
        }
      );
  
      const textElement = textRef.current;
      if (textElement) observer.observe(textElement);
  
      return () => {
        if (textElement) observer.unobserve(textElement);
      };
    }, []);
  
  // const [systemInfo, setSystemInfo] = useState({
  //   platform: "",
  //   userAgent: "",
  //   cpuCores: 0,
  // });

  // useEffect(() => {
  //   const fetchSystemInfo = () => {
  //     const platform = navigator.platform || 'Unknown';
  //     const userAgent = navigator.userAgent || 'Unknown';
  //     const cpuCores = navigator.hardwareConcurrency || 0; // Get number of CPU cores
  //     setSystemInfo({ platform, userAgent, cpuCores });
  //   };

  //   fetchSystemInfo();
  // }, []);

  //  useEffect(() => {
  //       // Ensure Typeform embed script is loaded
  //       const script = document.createElement('script');
  //       script.src = '//embed.typeform.com/next/embed.js';
  //       script.async = true;
  //       document.body.appendChild(script);
    
  //       return () => {
  //         document.body.removeChild(script);
  //       };
  //     }, []);
    

  // useEffect(() => {
  //   const detectMacArchitecture = () => {
  //    const check_list =   document.body.querySelector('.check_list');
  //    const bybAnalysis =   document.body.querySelector('.byb-analysis');
  //    const bybAudit =   document.body.querySelector('.byb-audit');
  //    const check_list_believe =   document.body.querySelector('.check_list.byb_believe');
  //   //  const legacy =   document.body.querySelector(' .legacy-content');

    
  //     const body = document.body;
      
  //     const { platform, cpuCores } = systemInfo;

  //     if (platform.includes('Win')) {
  //       // legacy.style.backgroundColor ="brown"
  //       body.style.backgroundColor = 'rgb(7 26 40)'; // Windows
  //       check_list.style.background ="rgb(7 26 40)"
  //       bybAnalysis.style.background ="rgb(7 26 40)"
  //       bybAudit.style.background="rgb(7 26 40)"
  //       check_list_believe.style.background="rgb(7 26 40)"
  //       // panel.style.background="rgb(7 26 40)"
  //       // legacy.style.background="rgb(7 26 40)"
        
  //       // check_list_believe
  //     }
  //      else if (platform.includes('Mac'))
  //        {  
  //       if (cpuCores >= 8) {
  //         body.style.backgroundColor = 'hwb(202.33deg 0.78% 82.35%)';
  //         check_list.style.background ="hwb(202.33deg 0.78% 82.35%)"
  //         bybAnalysis.style.background ="hwb(202.33deg 0.78% 82.35%)"
  //         bybAudit.style.background ="hwb(202.33deg 0.78% 82.35%)"// Mac M Series (ARM64)
  //         // panel.style.background="hwb(202.33deg 0.78% 82.35%)"
  //         // legacy.style.background="hwb(202.33deg 0.78% 82.35%)"

  //       } else {
  //         body.style.backgroundColor = 'hwb(204.29deg 1.18% 82.35%)'; // Mac Intel
  //         check_list.style.background ="hwb(204.29deg 1.18% 82.35%)"
  //         bybAnalysis.style.background ="hwb(204.29deg 1.18% 82.35%)"
  //         bybAudit.style.background ="hwb(204.29deg 1.18% 82.35%)"
  //         // panel.style.background="hwb(204.29deg 1.18% 82.35%)"
  //         // legacy.style.background="hwb(204.29deg 1.18% 82.35%)"

  //       }
  //     } 
   
  //   };

  //   detectMacArchitecture();
  // }, [systemInfo]); // Added systemInfo as a dependency to useEffect


  return (
    <>
      <section className="byb-analysis" ref={sectionRef} 
      style={{backgroundColor:"rgb(7, 26, 40)"}}>
        <div className="container">
          <div className="byb-analysis-header">
            <p
              ref={textRef}
              className={`fade-in-text ${isVisible ? "visible" : ""}`}
            >
              EVENTS  
            </p>
            <h2><span className="d-lg-block d-line d-md-block">Expert Insights</span> </h2>
          </div>

           <p className="text-center para_p p_txt ">
        Hear from branding leaders who’ve successfully navigated the dynamic world of strategy, design, and innovation. 
                    </p>
                    <div className="hide_btn">
                      <div data-tf-live="01JJV14J257ED52SCENJ77441Y" className="text-center position-relative"></div>
                    </div>
                    <button  className="blue_btn join_btn overlap_btn">Join</button>
                   <div className="whats_app text-center">
                    <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/marketing-practice.svg" alt="Marketing practice insights visual" className="center_img" />
                   </div>
        </div>

       
      </section>
    </> 
  );
}

export default ExpertsInsight;
